import {
    isEmpty } from 'lodash';
import printJS from 'print-js'; // from https://printjs.crabbly.com
import {
  detectBrowser,
  printDebugLog
} from '../constants/constant';
import { inferSilentChannel, trySilentPrint } from '../components/printer/silentPrinting';

export const handlePrint = (url, options = { isMobile: false }) => {
    const browser = detectBrowser();
    printDebugLog("handlePrint => ", `Mobile: ${options.isMobile}, Browser: ${browser}`);

    if (!options.isMobile && browser === 'Chrome') {
        printJS(url);
    } else {
        window.open(url, '_blank');
    }
};

export const getDynamicPrintUrl = ({ apiToken, shopId, billNo, k = 0, s = 0, g = 0 }) => {
    return `print://snpnextgen.com/snp/a2z/print?key1=${apiToken}&key2=${shopId}&key3=${billNo}&k1=${k}&s1=${s}&g1=${g}`;
};

export const handleInvoicePrint = async ({
    printRef,
    name,
    apiToken,
    shopId,
    billNo,
    backendBaseUrl,
    printOptions
    //setShowCustCopyDialog
}) => {
   // setShowCustCopyDialog?.(false); // safe optional call if passed

    const silentPrinted = await trySilentPrint({
        baseUrl: backendBaseUrl,
        shopHash: shopId,
        billNo: name?.includes('@') ? (name.split('@')[1] || billNo) : billNo,
        channel: printOptions?.silentChannel || inferSilentChannel(name),
        isMobile: printOptions?.isMobile,
        silentData: printOptions?.silentData,
    });
    if (silentPrinted) return;

    if (!isEmpty(printRef) && !printRef.includes('Successfully Print')) {
        const url = `${backendBaseUrl}files/${printRef}`;
        handlePrint(url, { isMobile: printOptions.isMobile });
    } else if (!isEmpty(printRef) && printRef.includes('Successfully Print')) {
        const lowerName = name.toLowerCase();
        let config = { k: 0, s: 0, g: 0, billNo, apiToken, shopId };

        if (lowerName.includes('gen')) config.g = 1;
        else if (lowerName.includes('kot')) {
            const [, extractedBillNo] = name.split("@");
            config.k = 1;
            config.billNo = extractedBillNo || billNo;
        } else if (lowerName.includes('shop')) config.s = 1;

        const dynHtml = getDynamicPrintUrl(config);
        window.location.href = dynHtml;
    }
};
